import ApplicationController from '../application_controller'

class ModulesController extends ApplicationController {
  connect () {
    const msOffice365Checkbox = document.querySelector('#company_enable_ms_integration')
    const customOffice365AppChekbox = document.querySelector('#company_modules_custom_ms_office_app')
    const wrapperCustomOffice365AppChekbox = document.querySelector('#tr-modules-custom-ms-office-app')

    if (!msOffice365Checkbox) return

    msOffice365Checkbox.addEventListener('change', (event) => {
      if (!customOffice365AppChekbox) return

      if (event.target.checked) {
        wrapperCustomOffice365AppChekbox.classList.remove('d-none')
      } else {
        customOffice365AppChekbox.checked = false
        wrapperCustomOffice365AppChekbox.classList.add('d-none')
      }
    })
  }
}

export default ModulesController
